// ============================================================
// ✅ AUTO-ADD CONFIG
// Ye variant har add-to-cart / buy-now ke saath cart me jayega
// ============================================================
// ✅ Har free item ko unique property do taaki cart me apna alag line item bane
// ✅ Free item ko us product ki variant id se tag karo jiske saath add hua
window.makeFreeItem = function (parentLineKey, productType) {
  var type = String(productType || '').trim().toLowerCase();

   var EXCLUDED = ['accessories', 'accessory'];
  if (EXCLUDED.indexOf(type) !== -1) return null;

  return {
    id: window.AUTO_ADD_VARIANT_ID,
    quantity: 1,
    parent_line_key: parentLineKey,   // ✅ not parent_id
    properties: { _free_gift: 'true', _gift_for: String(parentLineKey) }
  };
};

window.AUTO_ADD_VARIANT_ID = 52531274875178;

// ============================================================
// ✅ GLOBAL SERIAL QUEUE for /cart/add.js calls
// ------------------------------------------------------------
// Problem: agar user do products JALDI-JALDI (ek ke baad ek) add-to-cart
// karta hai, to har product ka apna "main item → free item" naturally do
// network calls ka chain chalta hai. Agar dusre product ka click pehle
// product ke calls khatam hone se PEHLE ho jaye, to un sab requests me
// OVERLAP ho jata hai — aur Shopify unhe hamesha usi order me commit
// nahi karta jis order me bheja gaya tha (network + server race
// condition). Isi wajah se kabhi free1/main2/free2/main1 jaisa
// bikhra hua (scrambled) order cart me dikh raha tha.
//
// Fix: chahe kitne bhi products, kitni bhi jaldi-jaldi add ho rahe hon —
// SAARI /cart/add.js requests is EK global queue se hoke guzarti hain.
// Queue guarantee karta hai ki ek waqt me sirf EK hi request Shopify ko
// jaye, aur agli request tabhi jaye jab pichli poori COMPLETE ho chuki
// ho. Isse cart me order hamesha wahi milta hai jis order me items
// add karne ki koshish ki gayi thi: main1, free1, main2, free2 ...
// ============================================================

window.__mappleCartAddQueue = window.__mappleCartAddQueue || Promise.resolve();

window.queueCartAdd = function (items) {
  const run = () =>
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then((res) =>
      res.json().then((data) => {
        if (!res.ok) throw data;
        return data;
      })
    );

  // Pichli queued call (chahe pass ho ya fail) khatam hone ke baad hi
  // ye chalegi — isse strict serial order milta hai.
  const result = window.__mappleCartAddQueue.then(run, run);

  // Ek call ka fail hona baaki queue ko hamesha ke liye block nahi karna
  // chahiye, isliye queue ko ek "safe" (always-resolved) promise se
  // aage badhate hain, jabki asli result (success/error) caller ko
  // 'result' se hi milta hai.
  window.__mappleCartAddQueue = result.catch(() => {});

  return result;
};

// ============================================================
// ✅ CART STATE (auto-add item ko count se exclude karta hai)
// ============================================================
window.__cachedCartState = null;
window.__cachedCartCount = null; // legacy — dusre sections ke liye sync rakha hai

window.buildCartState = function (cart) {
  let count = 0;
  let hasAutoItem = false;

  (cart.items || []).forEach((item) => {
    if (Number(item.variant_id) === Number(window.AUTO_ADD_VARIANT_ID)) {
      hasAutoItem = true;
    } else {
      count += item.quantity;
    }
  });

  window.__cachedCartCount = count;
  return { count: count, hasAutoItem: hasAutoItem };
};

window.getCartState = function (force = false) {
  if (!force && window.__cachedCartState) {
    return Promise.resolve(window.__cachedCartState);
  }

  return fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      window.__cachedCartState = window.buildCartState(cart);
      return window.__cachedCartState;
    })
    .catch((e) => {
      console.error('Cart fetch error:', e);
      return { count: 0, hasAutoItem: false, error: true };
    });
};

// Purana API surface intact — dusre sections isko call karte hain
window.checkCartLimit = function (limit = 4) {
  return window.getCartState().then((state) => ({
    allowed: state.count < limit,
    count: state.count
  }));
};

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.productType = this.dataset.productType || ''; // ✅ used to gate the free Travel Pass
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // Konsa button click hua, submitter se pata karo
        const clickedButton = evt.submitter || this.submitButton;
        const isBuyNow = clickedButton.classList.contains('cstm-buy-now');

        if (isBuyNow) {
          this.continueBuyNow(evt);
          return;
        }

        if (this.submitButton.getAttribute('data-added') === 'true') {
          window.location.href = '/cart';
          return;
        }

        this.continueSubmit(evt);
      }

      // ============================================================
      // ADD TO CART
      // ============================================================
      continueSubmit(evt) {
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);

        const mainId = formData.get('id');
        const comboItems = this.form.querySelectorAll('.combo-item');

        let items = [{ id: mainId, quantity: 1 }];

        // Add ALL combo products
        comboItems.forEach((el) => {
          const id = el.value;
          if (id) {
            items.push({ id: id, quantity: 1 });
          }
        });

        window.getCartState().then((state) => {
          // ✅ Limit check — auto-add item count me nahi aata
          if (state.count + items.length > 4) {
            this.showLimitPopup('You can only add maximum 4 items to cart');
            this.stopLoading();
            return;
          }

          // ✅ IMPORTANT: main/combo items PEHLE add karo, free item ALAG call me
          // BAAD me add karo. Ek hi /cart/add.js call me dono bhejne par Shopify
          // cart line-item order guarantee nahi karta — isi wajah se free item
          // kabhi-kabhi main product se PEHLE dikh jata tha. Do sequential calls
          // karne se order hamesha fix rehta hai: main product pehle, free baad me.
          this.addItemsToCart(items)
            .then((res) => this.addFreeGiftItem(res, mainId))
            .then(() => {
              this.showCartPopup();
              this.stopLoading();
              this.markAddedToCart();

              return fetch('/cart.js')
                .then((res) => res.json())
                .then((cart) => {
                  // ✅ Cache update karo taaki agli baar fetch na lage
                  window.__cachedCartState = window.buildCartState(cart);

                  this.updateCartBubble(cart);
                  if (this.cart) {
                    try {
                      this.cart.renderContents(cart);
                    } catch (e) {
                      console.error('Cart render error:', e);
                    }
                  }
                });
            })
            .catch((e) => {
              console.error(e);
              this.stopLoading();
            });
        });
      }

      // ============================================================
      // BUY NOW
      // ============================================================
      continueBuyNow(evt) {
        const buyNowButton = evt.submitter || this.querySelector('.cstm-buy-now');

        if (buyNowButton.getAttribute('aria-disabled') === 'true') return;

        buyNowButton.setAttribute('aria-disabled', true);
        buyNowButton.classList.add('loading');

        const formData = new FormData(this.form);

        const mainId = formData.get('id');
        const comboItems = this.form.querySelectorAll('.combo-item');

        let items = [{ id: mainId, quantity: 1 }];

        comboItems.forEach((el) => {
          const id = el.value;
          if (id) {
            items.push({ id: id, quantity: 1 });
          }
        });

        window.getCartState().then((state) => {
          // ✅ Yahan bhi main item pehle, free item alag/baad me — order fix ke liye
          this.addItemsToCart(items)
            .then((res) => this.addFreeGiftItem(res, mainId))
            .then(() => {
              window.__cachedCartState = null; // navigate kar rahe hain, cache stale
              window.location.href = '/cart';
            })
            .catch((e) => {
              console.error(e);
              buyNowButton.classList.remove('loading');
              buyNowButton.removeAttribute('aria-disabled');
            });
        });
      }

      // ============================================================
      // Real (main + combo) items ko cart me add karta hai
      // ✅ Global queue se hoke jaata hai — dusre product ke saath race
      // na ho, isliye
      // ============================================================
      addItemsToCart(items) {
        return window.queueCartAdd(items);
      }

      // ============================================================
      // ✅ FREE GIFT ITEM — main items ke SUCCESS ke BAAD, ALAG call me
      // add hota hai. Isse cart me order hamesha guaranteed rehta hai:
      // main product pehle, free product uske turant baad.
      //
      // ✅ SAFETY NET: agar free variant sold out / unpublished hai to
      // ye call fail hogi, lekin us error ko yahin swallow kar dete hain
      // taaki main add-to-cart flow (jo already succeed ho chuka hai)
      // break na ho.
      // ============================================================
      addFreeGiftItem(addResponse, mainVariantId) {
  const added = (addResponse && addResponse.items) || [];
  const parentLine = added.find(
    (i) => String(i.variant_id) === String(mainVariantId)
  );
  if (!parentLine || !parentLine.key) return Promise.resolve(null);

  const freeItem = window.makeFreeItem(parentLine.key, this.productType);
  if (!freeItem) return Promise.resolve(null);

  return window.queueCartAdd([freeItem]).catch((err) => {
    console.warn('Free gift item add failed, continuing without it:', err);
    return null;
  });
}

      showCartPopup() {
        window.positionAndShowPopup(this.submitButton);
      }

      updateCartBubble(cart) {
        window.updateGlobalCartBubble(cart);
      }

      markAddedToCart() {
        if (this.submitButtonText) {
          this.submitButtonText.textContent = 'View Cart';
        }
        this.submitButton.classList.add('added-to-cart');
        this.submitButton.setAttribute('data-added', 'true');
      }

      stopLoading() {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      showLimitPopup(message) {
        let popup = document.querySelector('.cart-limit-popup');

        if (!popup) {
          popup = document.createElement('div');
          popup.className = 'cart-limit-popup';
          document.body.appendChild(popup);
        }

        popup.textContent = message;
        popup.classList.add('active');

        setTimeout(() => {
          popup.classList.remove('active');
        }, 3000);
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// ============================================================
// ✅ GLOBAL — dusre sections (jaise preowned-picks) bhi isko use kar sakte hain
// ============================================================
window.showAddToCartPopup = function () {
  let popup = document.getElementById('cstmCartPopup');

  if (!popup) {
    popup = document.createElement('div');
    popup.id = 'cstmCartPopup';
    popup.className = 'cstm-cart-popup';
    popup.innerHTML = `
      <span class="cstm-cart-popup__text">Item added to your cart</span>
      <a href="/cart" class="cstm-cart-popup__view">VIEW CART</a>
    `;
    document.body.appendChild(popup);
  }

  return popup;
};

window.positionAndShowPopup = function (buttonEl) {
  const popup = window.showAddToCartPopup();

  popup.classList.add('show');

  clearTimeout(window._cstmPopupTimer);
  window._cstmPopupTimer = setTimeout(() => {
    popup.classList.remove('show');
  }, 3000);
};

window.updateGlobalCartBubble = function (cart) {
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (!cartIcon) return;

  let bubble = cartIcon.querySelector('.cart-count-bubble');

  if (cart.item_count > 0) {
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = `
        <span aria-hidden="true"></span>
        <span class="visually-hidden">items in cart</span>
      `;
      cartIcon.appendChild(bubble);
    }
    const countSpan = bubble.querySelector('span[aria-hidden]');
    if (countSpan)
      countSpan.textContent = cart.item_count < 100 ? cart.item_count : '';
  } else if (bubble) {
    bubble.remove();
  }
};

// ❌ Purana DOMContentLoaded cache block HATA diya gaya hai.
// Reason: header bubble ka count auto-add item ko bhi include karta hai,
// isliye usse cache seed karne par 4-item limit ka math galat ho jata.
// Ab pehle click par ek real /cart.js fetch hota hai, uske baad cache chalta hai.